import { faPipe } from "@fortawesome/pro-duotone-svg-icons/faPipe";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const EditorToolbarDivider: React.FC = () => (
  <div className="text-slate-200">
    <FontAwesomeIcon icon={faPipe} />
  </div>
);
